import TimeSlider from "./TimeSlider";

import { BsCaretLeft, BsCaretRight } from "react-icons/bs";
import { AiOutlinePause } from "react-icons/ai";
import SpeedDropdown from "../../ui/SpeedDropdown";
import styled from "styled-components";
// import useIsMobile from '@/hooks/useIsMobile';
import { useTimeControlStore, useTimeStore } from "@graphic/stores";
import { Button, IconButton, SystemStyleObject } from "@chakra-ui/react";

const defaultHoverStyle: SystemStyleObject = {
  bg: "white",
  opacity: 0.8,
  color: "black"
};

const selectedHoverStyle: SystemStyleObject = {
  bg: "blue",
  opacity: 0.8,
  color: "white"
};

function Timer({ timeFormat }: { timeFormat: string }) {
  const { play, speed, direction, setSpeed, setPlay, setDirection } =
    useTimeControlStore();
  const { time } = useTimeStore();

  const handleCurrentSetTime = () => {
    const { setCurrentTime } = useTimeStore.getState();
    setCurrentTime();
  };

  const speeds = [1, 5, 10, 50];
  const playState = play ? direction : "pause";

  return (
    <Container>
      <ButtonContainer $isMobile={true}>
        <Button onClick={() => handleCurrentSetTime()}>
          <ButtonText>Current</ButtonText>
        </Button>

        <TimerButton
          aria-label="backward"
          icon={<BsCaretLeft />}
          bg={playState === "backward" ? "blue" : "white"}
          color={playState === "backward" ? "white" : "black"}
          selected={playState === "backward"}
          onClick={() => {
            setDirection("backward");
            setPlay(true);
          }}
        />

        <TimerButton
          aria-label="pause"
          bg={playState === "pause" ? "blue" : "white"}
          color={playState === "pause" ? "white" : "black"}
          selected={playState === "pause"}
          icon={<AiOutlinePause />}
          onClick={() => setPlay(false)}
        />

        <TimerButton
          aria-label="forward"
          bg={playState === "forward" ? "blue" : "white"}
          color={playState === "forward" ? "white" : "black"}
          icon={<BsCaretRight />}
          selected={playState === "forward"}
          onClick={() => {
            setDirection("forward");
            setPlay(true);
          }}
        />

        <SpeedDropdown
          items={speeds}
          selected={speed}
          onChange={setSpeed}
          onFormat={s => `${s}x`}
          itemtype={"speed"}
        />
        <div
          style={{
            fontSize: "1rem",
            fontWeight: "bold",
            whiteSpace: "pre",
            lineHeight: "1.2rem",
            minWidth: "7rem"
          }}
        >
          {time.format("YYYY-MM-DD\nHH:mm:ss")} ({timeFormat})
        </div>
      </ButtonContainer>

      <TimeSlider />
    </Container>
  );
}
export default Timer;

const TimerButton = props => {
  return (
    <IconButton
      {...props}
      _hover={props.selected ? selectedHoverStyle : defaultHoverStyle}
    />
  );
};

const Container = styled.div`
  position: absolute;
  bottom: 0;
  z-index: 10;
  background-color: transparent;
  color: white;
  width: 100%;
  /* padding-bottom: 12px; */
`;

const ButtonContainer = styled.div<{ $isMobile: boolean }>`
  display: flex;
  gap: 12px;
  /* justify-content: flex-start; */

  justify-content: ${({ $isMobile }) => ($isMobile ? "center" : "flex-start")};
  align-items: center;
  padding: 0 3rem;
`;

const ButtonText = styled.span`
  font-size: 0.8rem;
  font-weight: 500;
  letter-spacing: 0.02rem;
  color: #000;
`;
